










import { Vue, Component } from 'vue-property-decorator';

@Component({
    components: {}
})
export default class RgTemplateSettings extends Vue {
    activeType: string = 'announcement';

    created() {
        if (this.$route.name === 'space_template_settings_question') {
            this.activeType = 'question';
        }
    }

    activeTypeChange(val) {
        this.$router
            .push({
                name: `space_template_settings_${val}`
            })
            .catch(e => e);
    }
}
